import { ClientName } from '@/data/clientsData';

const LICARD_CLIENTS: ReadonlyArray<ClientName> = [
  ClientName.LICARD,
  ClientName.LICARD_UAT,
];

export function isLicardClient(): boolean {
  return LICARD_CLIENTS.includes(process.env.VUE_APP_CLIENT_NAME as ClientName);
}
